// extracted by mini-css-extract-plugin
module.exports = {"coin":"styles_coin__F0w9L","skeleton-animation":"styles_skeleton-animation__l4Bq9"};